import { useState } from "react";
import axios from "axios";
import { useGlobalContext } from "../GlobalContext";

export default function useVolunteerLogin() {
  const [loading, setLoading] = useState(false);

  const {
    baseurl,
    setIsUnauthorised,token,
  } = useGlobalContext();

  const login = async ({
    mobile,
    password,
    step,
    otp,
  }) => {
    setLoading(true);

    try {
      const payload = {
        mobile,
        password,
        step: step.toString(),
        ipAddress: "",
        otp: step === 2 ? otp : "",
        latitude: "",
        longitude: "",
        deviceId: "",
        userType: "Distributor", 
      };

      const response = await axios.post(
        `${baseurl}/api/Volunteer/v1.0/volunteerLogin`,
        payload,
         {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
      );

      if (response.data.responseCode === "00") {
        const userData = response.data.response;

        if (step === 1) {
          return { success: true, nextStep: 2 };
        }

        if (step === 2) {
          sessionStorage.setItem("volunteer", "true");
          sessionStorage.setItem("volunteerData", JSON.stringify(userData));
          sessionStorage.setItem("volunteerToken", userData.accessToken);

          return { success: true, completed: true };
        }
      }

      if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
        return { success: false };
      }

      return {
        success: false,
        message: response.data.responseMessage,
      };

    } catch (error) {
      return {
        success: false,
        message: "Login failed. Please try again.",
      };
    } finally {
      setLoading(false);
    }
  };

  return { login, loading };
}
